import { render, staticRenderFns } from "./HeadTag.vue?vue&type=template&id=20898adc&scoped=true&"
import script from "./HeadTag.vue?vue&type=script&lang=js&"
export * from "./HeadTag.vue?vue&type=script&lang=js&"
import style0 from "./HeadTag.vue?vue&type=style&index=0&id=20898adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20898adc",
  null
  
)

export default component.exports